import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { usersAPI } from '../../services/api';

export const fetchUsers = createAsyncThunk('users/fetchAll', async (params, { rejectWithValue }) => {
  try { const { data } = await usersAPI.list(params); return data; }
  catch (err) { return rejectWithValue(err.response?.data); }
});

export const createUser = createAsyncThunk('users/create', async (payload, { rejectWithValue }) => {
  try { const { data } = await usersAPI.create(payload); return data; }
  catch (err) { return rejectWithValue(err.response?.data); }
});

export const updateUser = createAsyncThunk('users/update', async ({ id, data: payload }, { rejectWithValue }) => {
  try { const { data } = await usersAPI.update(id, payload); return data; }
  catch (err) { return rejectWithValue(err.response?.data); }
});

export const deleteUser = createAsyncThunk('users/delete', async (id, { rejectWithValue }) => {
  try { await usersAPI.delete(id); return id; }
  catch (err) { return rejectWithValue(err.response?.data); }
});

const usersSlice = createSlice({
  name: 'users',
  initialState: { list: [], loading: false, error: null },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchUsers.pending, (s) => { s.loading = true; })
      .addCase(fetchUsers.fulfilled, (s, a) => { s.loading = false; s.list = a.payload; })
      .addCase(fetchUsers.rejected, (s) => { s.loading = false; })
      .addCase(createUser.fulfilled, (s, a) => { s.list.push(a.payload); })
      .addCase(updateUser.fulfilled, (s, a) => {
        const i = s.list.findIndex(u => u.id === a.payload.id);
        if (i >= 0) s.list[i] = a.payload;
      })
      .addCase(deleteUser.fulfilled, (s, a) => {
        s.list = s.list.filter(u => u.id !== a.payload);
      });
  },
});

export default usersSlice.reducer;
